export const MOCK_ADMIN_LOGIN = 'admin';
export const MOCK_ADMIN_PASSWORD = 'admin123';
